// extracted by mini-css-extract-plugin
module.exports = {"container":"gKF6E24emaHrZU-XVRUeZ","visible":"zEUbXWhmBrfp9F7lS3hlp","cancelBtn":"_1jsfU7elNXCpBGuceChdwI","icon":"_3L7zwdZ7JR6hiDxafeNwOb","saveBtn":"_2gqcUjMQCDH83Tu45byHdf"};